import { render, staticRenderFns } from "./BExecAgrHistModal.vue?vue&type=template&id=0ddbdbaa&scoped=true&"
import script from "./BExecAgrHistModal.vue?vue&type=script&lang=ts&"
export * from "./BExecAgrHistModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddbdbaa",
  null
  
)

export default component.exports